import chunk from 'lodash/chunk'
import flatten from 'lodash/flatten'
import LocationApi from '@/api/LocationApi/LocationApi'
import updateReqMaker from '@/api/PointGroup/LocationGroupOperation/updateReqMaker'
import addNewLocationReqMaker from '@/api/PointGroup/LocationGroupOperation/addNewLocationReqMaker'
import deleteReqMaker from '@/api/PointGroup/LocationGroupOperation/deleteReqMaker'
import LocationModel from './Location'

export default class LocationRepository {
  static async getList(locationGroupType, locationGroupId) {
    const result = await LocationApi.fetchLocationList(
      locationGroupId,
      locationGroupType,
    )
    return result.items.map(LocationModel.assign)
  }

  static async savePoiLocation(
    poiLocationGroupId,
    categoryId,
    conditions,
    administrativeDistrictType,
    area,
  ) {
    const trimmedConditions = conditions.map(condition => {
      return {
        poiSubCategoryId: condition.poiSubCategoryId,
        type: condition.type,
        value: condition.value,
        condition: condition.condition,
        valueIds: condition.valueIds,
      }
    })
    const res = await LocationApi.savePoiLocation(
      poiLocationGroupId,
      categoryId,
      trimmedConditions,
      administrativeDistrictType,
      area,
    )
    return res
  }
  /**
   *
   * @param {number} locationGroup
   * @param {LocationModel[]} locations
   */
  static async saveBulkCustomLocations(locationGroupId, locations) {
    const toUpdateLocations = updateReqMaker(locations)
    const toDeleteLocations = deleteReqMaker(locations)
    const toAddNewLocations = addNewLocationReqMaker(locations)
    const reqLocations = [
      ...toUpdateLocations,
      ...toDeleteLocations,
      ...toAddNewLocations,
    ]
    // 一度のリクエストの上限が100地点なので、分割リクエストを行う
    const errorChunks = []
    const chunkedLocations = chunk(reqLocations, 100)
    for (let chunk of chunkedLocations) {
      try {
        const locations = chunk.map(data => data.serialized)
        await LocationApi.postCustomLocations({
          locationGroupId,
          locations,
        })
      } catch (e) {
        errorChunks.push(chunk)
      }
    }

    const errorLocations = flatten(errorChunks)
    if (errorLocations.length > 0) {
      const error = new Error(
        `一部地点登録に失敗しました: ${errorLocations.length}件`,
      )
      error.locations = errorLocations
      throw error
    }
    return true
  }
}
